<template>
  <div class="w-full pt-3 border-t border-gray-200 dark:border-gray-700">
    <div class="w-full flex items-center">
      <h2 class="font-semibold text-lg pb-3">Kontakti</h2>
    </div>

    <div class="w-full">
      <template v-for="(contact, index) in contacts" :key="index">
        <ContactDetails :contact="contact" />
      </template>
    </div>
  </div>
</template>

<script>
import ContactDetails from "@/components/Customers/AdditionalFields/Contacts/ContactDetails"

export default {
  name: "ShowContacts",
  components: {
    ContactDetails
  },
  props: ['contacts', 'showContacts'],
  methods: {
    hideForm(){
      this.$emit('update:showContacts', false)
    },
  }
}
</script>

<style>

</style>